import { AbstractLocalStorage } from "./AbstractLocalStorage";

import { EnvGlobalsHandler } from "../../basic/EnvGlobalsHandler";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("LocalStorage.WindowLocalStorage");

/**
 * Wrapper to access LocalStorage data from window.localStorage
 */
export class WindowLocalStorage extends AbstractLocalStorage {
    /**
     * Generate section name used when accessing window.localStorage object.
     */
    private get localStorageKey(): string {
        return ["ggs.gameData", EnvGlobalsHandler.globals.gameId, EnvGlobalsHandler.globals.networkId, this._section].join("_");
    }

    /**
     * Read data from window.localStorage based on current section.
     *
     * Try to access window.localStorage.
     */
    public read(): Promise<any> {
        let localStorageItem: object = JSON.parse(window.localStorage.getItem(this.localStorageKey));

        logger.info("reading data from window.localStorage.");
        logger.info(localStorageItem);

        this._data = localStorageItem || {};

        return Promise.resolve(this._data);
    }

    /**
     * Write data on window.localStorage based on current section.
     */
    public write(): void {
        logger.info("writing data on window.localStorage.");

        window.localStorage.setItem(this.localStorageKey, JSON.stringify(this._data));
    }
}
